import Scroller from 'vux/src/components/scroller/index.vue'

const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
}

const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}

export default {
name: 'vidoeInfo',
components:{
Scroller
},
data () {
return {
pulldownDefaultConfig: pulldownDefaultConfig,
pullupDefaultConfig: pullupDefaultConfig,
videoInfo:'',
videoPraiseIcon:require('../../assets/images/praise.png'),
isVideoComment:false,//视频评论
videoCommentInfo:'',//视频评论内容
page:1,
isReply:false,
replyIndex:-1,
replyInfo:'',//回复内容
commentList:[],
replyPraiseIndex:-1,//评论点赞索引
total:0,
}
},
methods: {
getVideoInfo(){
this.$request.post('/creativeVideo/play',{
vedioId:this.$route.query.videoId
}).then((res)=>{
this.videoInfo = res.obj
})
},
videoPraise(fabulousType,type){
this.$request.post('/creativeVideo/fabulousCreative',{
fabulousType:fabulousType,
type:type,
vedioId:this.$route.query.videoId
}).then((res)=>{
if(res.code ==0 ){
this.videoPraiseIcon = require('../../assets/images/praiseColor.png')
}else{
this.$vux.toast.show({
type: 'warn',
text: res.msg
})
}

})
},
videoComment(commentInfo,commentType,commentId){
if(commentInfo == '') {
this.$vux.toast.show({
type: 'warn',
text: '请输入评论'
})
return false
}
this.$request.post('/creativeVideo/commentCreative',{
commentCount:commentInfo,
commentType:commentType,
commentId:commentId,
vedioId:this.$route.query.videoId
}).then((res)=>{
if(res.code ==0) {
this.$vux.toast.show({
type: 'success',
text: '评论成功'
})
this.videoCommentInfo = ''
if(commentType == '回复') {
this.replyIndex = -1
}
if(commentType == '评论') {
this.isVideoComment = false
}
this.getComment()
}else{
this.$vux.toast.show({
type: 'warn',
text: res.msg
})
}

})
},
getComment(cb){
this.$request.post('/creativeVideo/getCreativeCommentById',{
page:this.page,
rows:5,
vedioId:this.$route.query.videoId
}).then((res)=>{
if(res.code ==0) {

this.total = res.obj.total
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
cb(res.obj.rows)
}else{
this.$vux.toast.show({
type: 'warn',
text: res.msg
})
}

})
},
reply(index){
this.replyIndex == index?this.replyIndex = -1:this.replyIndex = index
},
commentPraise(commenId,index){
this.$request.post('/creativeVideo/commentFabulousCreative',{
type:'新增',
commenId:commenId
}).then((res)=>{
if(res.code ==0 ){
this.replyPraiseIndex == index?this.replyPraiseIndex = -1:this.replyPraiseIndex = index
this.refresh()
}else{
this.$vux.toast.show({
type: 'warn',
text: res.msg
})
}

})
},
refresh() {
this.page = 1
this.getComment(data => {
this.commentList = data
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 5) {
this.$refs.scrollerBottom.disablePullup()
}
this.$vux.toast.show({
type: 'success',
text: '成功'
})
})
this.page += 1
},
loadMore() {
this.getComment(data => {
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
this.$refs.scrollerBottom.enablePullup()
if (data.length < 5) {
this.$refs.scrollerBottom.disablePullup()
}
if(this.page == 1 && data.length == 0){
this.noData = true
this.$refs.scrollerBottom.disablePullup()
}else{
this.noData = false
}
this.commentList = this.commentList.concat(data)
this.$refs.scrollerBottom.donePullup()
this.page += 1
})
},
},
computed: {

},
created() {
this.getVideoInfo()
this.loadMore()
},
mounted() {

},
}


// WEBPACK FOOTER //
// ./src/views/videoInfo/script.js